import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

//  Async thunk to fetch config data
export const loadConfigs = createAsyncThunk("config/loadConfigs", async () => {
    const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/configs`,
        { withCredentials: true },
    );

    const result = {};

    response.data.forEach((cfg) => {
        if(cfg.is_enabled) {
            result[cfg.field_name] = cfg.field_value;
        }
    });

    return result;
});

//  Async thunk to fetch public config data (no authentication required)
export const loadPublicConfigs = createAsyncThunk(
    "config/loadPublicConfigs",
    async () => {
        const response = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/api/configs/public`,
        );

        const result = {};

        response.data.forEach((cfg) => {
            if(cfg.is_enabled) {
                result[cfg.field_name] = cfg.field_value;
            }
        });

        return result;
    },
);

const configSlice = createSlice({
    name: "config",

    initialState: {
        values: {},
        loading: false,
        error: null,
    },

    reducers: {},

    extraReducers: (builder) => {
        builder
            .addCase(loadConfigs.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(loadConfigs.fulfilled, (state, action) => {
                state.values = action.payload;
                state.loading = false;
            })
            .addCase(loadConfigs.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(loadPublicConfigs.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(loadPublicConfigs.fulfilled, (state, action) => {
                state.values = { ...state.values, ...action.payload };
                state.loading = false;
            })
            .addCase(loadPublicConfigs.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export default configSlice.reducer;
